import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, MapPin } from "lucide-react";
import { api } from "../../lib/api";
import { ImageUploadField } from "./ImageUploadField";

const opts = { withCredentials: true };
const inputCls = "bg-[#FAF9F6] border border-[#D1CFC7] focus:border-[#2C402E] px-3 py-2 outline-none font-body text-sm min-w-0";

export function PickupPointsManager() {
  const [items, setItems] = useState([]);
  const [dirty, setDirty] = useState(false);
  useEffect(() => { api.get("/pickup-points").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const update = (i, k, v) => { setItems(items.map((it, j) => (j === i ? { ...it, [k]: v } : it))); setDirty(true); };
  const add = () => { setItems([...items, { city: "", name: "", address: "", kind: "librairie", logo_url: null }]); setDirty(true); };
  const remove = (i) => { setItems(items.filter((_, j) => j !== i)); setDirty(true); };
  const save = async () => {
    const clean = items.filter((i) => i.city.trim() && i.name.trim()).map((i) => ({ ...i, address: i.address || null, logo_url: i.logo_url || null, kind: i.kind || "librairie" }));
    try {
      const r = await api.put("/admin/pickup-points", { items: clean }, opts);
      setItems(r.data); setDirty(false);
      toast.success("Librairies de retrait enregistrées");
    } catch { toast.error("Enregistrement impossible"); }
  };

  return (
    <section data-testid="pickup-points-manager" className="border border-[#D1CFC7] p-5 mb-10">
      <div className="flex items-center justify-between mb-2">
        <h3 className="flex items-center gap-2 font-serif text-2xl text-[#1A1A1A]"><MapPin size={18} className="text-[#9E4735]" /> Librairies et relais Pick & Read (livre papier)</h3>
        <button onClick={add} data-testid="add-pickup-point" className="text-xs font-body text-[#2C402E] flex items-center gap-1"><Plus size={12} /> Ajouter</button>
      </div>
      <p className="text-xs font-body text-[#757575] mb-4">Proposées au lecteur quand il commande le livre papier. Pour chaque livre, cochez dans la fiche de l’extrait les points où il est disponible : seuls ceux-là sont affichés au lecteur. Le logo est facultatif (sans logo, le nom s’affiche).</p>
      <div className="space-y-2">
        {items.map((it, i) => (
          <div key={it.id || i} data-testid={`pickup-row-${i}`} className="border border-[#E8E4D9] p-3 space-y-2">
            <div className="grid grid-cols-1 md:grid-cols-[150px_1fr_1.4fr_1.6fr_auto] gap-2 items-center">
              <select value={it.kind || "librairie"} onChange={(e) => update(i, "kind", e.target.value)} data-testid={`pickup-kind-${i}`} className={inputCls}>
                <option value="librairie">Librairie</option>
                <option value="pick_read">Relais Pick &amp; Read</option>
              </select>
              <input value={it.city} onChange={(e) => update(i, "city", e.target.value)} placeholder="Ville (ex. Yaoundé)" data-testid={`pickup-city-${i}`} className={inputCls} />
              <input value={it.name} onChange={(e) => update(i, "name", e.target.value)} placeholder="Nom" data-testid={`pickup-name-${i}`} className={inputCls} />
              <input value={it.address || ""} onChange={(e) => update(i, "address", e.target.value)} placeholder="Adresse (optionnel)" data-testid={`pickup-address-${i}`} className={inputCls} />
              <button onClick={() => remove(i)} data-testid={`pickup-delete-${i}`} aria-label="Supprimer" className="text-[#9E4735] px-2"><Trash2 size={14} /></button>
            </div>
            <ImageUploadField label="Logo (optionnel)" value={it.logo_url || ""} onChange={(v) => update(i, "logo_url", v)} testid={`pickup-logo-${i}`} />
          </div>
        ))}
        {items.length === 0 && <p className="text-sm font-body text-[#757575]">Aucune librairie pour l'instant.</p>}
      </div>
      {dirty && <button onClick={save} data-testid="save-pickup-points" className="mt-4 bg-[#2C402E] text-[#FAF9F6] px-5 py-2 text-sm font-body">Enregistrer les points de retrait</button>}
    </section>
  );
}
